// src/pages/SurfaceModeWrapper.js
import React from "react";
import TapToMeasure from "./TapToMeasure";   // <-- FIXED IMPORT

export default function SurfaceModeWrapper() {
  return (
    <div style={{ padding: "40px" }}>
      <h1 style={{ fontSize: "40px", marginBottom: "20px", color: "#003a78" }}>
        Surface Mode (Backsplashes, Walls, Windows)
      </h1>

      <p style={{ fontSize: "18px", marginBottom: "20px", color: "#444" }}>
        Upload an image, tap the AI Stick for calibration, then tap to measure
        width & height.
      </p>

      {/* Render the FULL Tap-to-Measure experience */}
      <TapToMeasure />
    </div>
  );
}
